const routes = [
  {
    path: "/",
    redirect: "/homePage",
  },
  {
    path: "/login",
    component: () => import("@/views/Login"),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: "/client/releases",
    title: "客户端版本记录",
    component: () => import("@/views/ClientReleases"),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: "/redirect",
    component: () => import("@/views/Redirect"),
    meta: {
      hiddenTag: true,
    },
  },
  {
    path: "/register",
    component: () => import("@/views/Register"),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: "/personal",
    name: "Personal",
    title: "个人中心",
    component: () => import("@/views/Personal"),
  },
  {
    path: "/homePage",
    name: "Homepage",
    title: "我的首页",
    component: () => import("@/views/HomePage"),
  },
  {
    path: "/uiDesign",
    name: "UIDesign",
    title: "UI设计",
    component: () => import("@/views/UIDesign"),
  },
  {
    path: "/homePage/moreTemplates",
    title: "更多模板",
    component: () => import("@/views/MoreTemplates"),
  },
  //素材管理相关
  {
    path: "/privateResource",
    title: "私有资源库",
    component: () => import("@/views/PrivateResource"),
    children: [
      {
        path: "/privateResource",
        redirect: "/privateResource/materials",
      },
      {
        path: "/privateResource/materials",
        name: "privateMaterials",
        title: "素材管理",
        component: () => import("@/views/PrivateResource/Materials"),
      },
      {
        path: "/privateResource/directiveTypes",
        title: "指令类型",
        component: () => import("@/views/PrivateResource/DirectiveTypes"),
      },
      {
        path: "/privateResource/directiveTypes/edit",
        title: "编辑",
        component: () => import("@/views/PrivateResource/DirectiveTypes/Edit"),
      },
      {
        path: "/privateResource/directiveTypes/add",
        title: "新增",
        component: () => import("@/views/PrivateResource/DirectiveTypes/Edit"),
      },
      {
        path: "/privateResource/manage",
        title: "私有指令",
        component: () => import("@/views/PrivateResource/Directives"),
      },
      {
        path: "/privateResource/manage/edit",
        title: "编辑",
        component: () => import("@/views/PrivateResource/Directives/Edit"),
      },
      {
        path: "/privateResource/manage/add",
        title: "新增",
        component: () => import("@/views/PrivateResource/Directives/Edit"),
      },
    ]
  },
//公共资源库
{
  path: "/publicResource",
  title: "公共资源库",
  component: () => import("@/views/PublicResource"),
  children: [
    {
      path: "/publicResource",
      redirect: "/publicResource/publicDirective",
    },
    {
      path: "/publicResource/publicDirective",
      title: "公共指令",
      component: () => import("@/views/PublicResource/PublicDirective")
    },
    {
      path: "/publicResource/publicDirective/add",
      title: "公共指令新增",
      component: () => import("@/views/PublicResource/PublicDirective/Edit")
    },
    {
      path: "/publicResource/publicDirective/edit",
      title: "公共指令编辑",
      component: () => import("@/views/PublicResource/PublicDirective/Edit")
    },
    {
      path: "/publicResource/publicDirective/view",
      name: 'publicDirectiveView',
      title: "公共指令查看",
      component: () => import("@/views/PublicResource/PublicDirective/Edit")
    },
    {
      path: "/publicResource/publicMaterial",
      title: "公共素材",
      component: () => import("@/views/PublicResource/PublicMaterial"),
    },
  ],
},
//客户端管理：APK / QT
{
  path: "/clientManage",
  redirect: "/clientManage/apk",
},
{
  path: "/clientManage/apk",
  title: "APK管理",
  component: () => import("@/views/APKPage")
},
{
  path: "/clientManage/apk/add",
  title: "apk新增",
  component: () => import("@/views/APKPage/Edit")
},
{
  path: "/clientManage/apk/edit",
  title: "apk修改",
  component: () => import("@/views/APKPage/Edit")
},
{
  path: "/clientManage/qt",
  title: "QT管理",
  component: () => import("@/views/QTPage")
},
{
  path: "/clientManage/qt/add",
  title: "qt新增",
  component: () => import("@/views/QTPage/Edit")
},
{
  path: "/clientManage/qt/edit",
  title: "qt修改",
  component: () => import("@/views/QTPage/Edit")
},
{
  path: "/clientManage/mac",
  title: "Mac管理",
  component: () => import("@/views/QTPage")
},
{
  path: "/clientManage/mac/add",
  title: "Mac新增",
  component: () => import("@/views/QTPage/Edit")
},
{
  path: "/clientManage/mac/edit",
  title: "Mac修改",
  component: () => import("@/views/QTPage/Edit")
},
{
  path: "/clientManage/ios",
  title: "iOS管理",
  component: () => import("@/views/QTPage")
},
{
  path: "/clientManage/ios/add",
  title: "iOS新增",
  component: () => import("@/views/QTPage/Edit")
},
{
  path: "/clientManage/ios/edit",
  title: "iOS修改",
  component: () => import("@/views/QTPage/Edit")
},
{
  path: "/apk",
  redirect: "/clientManage/apk",
},
{
  path: "/apk/add",
  redirect: "/clientManage/apk/add",
},
{
  path: "/apk/edit",
  redirect: "/clientManage/apk/edit",
},
{
  path: "/qt",
  redirect: "/clientManage/qt",
},
{
  path: "/qt/add",
  redirect: "/clientManage/qt/add",
},
{
  path: "/qt/edit",
  redirect: "/clientManage/qt/edit",
},
  //工程管理相关
  {
    path: "/projects",
    title: "工程管理",
    component: () => import("@/views/Projects"),
  },
  {
    path: "/projects/projectsEdit",
    title: "工程编辑",
    component: () => import("@/views/VisualDrag"),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: "/projects/add",
    title: "新建工程",
    component: () => import("@/views/VisualDrag"),
    meta: {
      hideMenu: true,
    },
  },
  //帮助
  {
    path: "/helps",
    title: "帮助",
    component: () => import("@/views/Helps"),
  },
  {
    path: "/helps/edit",
    title: "详情",
    component: () => import("@/views/Helps/Detail"),
  },
  //用户管理
  {
    path: "/userManage",
    title: "用户管理",
    component: () => import("@/views/UserManage"),
    children: [
      {
        path: "/userManage",
        redirect: "/userManage/users",
      },
      {
        path: "/userManage/users",
        title: "注册用户",
        component: () => import("@/views/UserManage/Users"),
      },
      {
        path: "/userManage/managers",
        title: "管理员",
        component: () => import("@/views/UserManage/Managers"),
      },
      {
        path: "/userManage/transferLogs",
        title: "工程交接记录",
        component: () => import("@/views/UserManage/TransferLogs"),
      },
      {
        path: "/userManage/canvasAiModels",
        title: "画布AI模型",
        component: () => import("@/views/UserManage/CanvasAiModels"),
      },
      {
        path: "/userManage/materialThumbnail",
        title: "缩略图任务",
        component: () => import("@/views/UserManage/MaterialThumbnail"),
      },
    ],
  },
  {
    path: "/userManage/users/edit",
    title: "编辑",
    component: () => import("@/views/UserManage/Users/Edit"),
  },
  {
    path: "/userManage/managers/edit",
    title: "编辑",
    component: () => import("@/views/UserManage/Managers/Edit"),
  },
  {
    path: "/userManage/managers/add",
    title: "新增",
    component: () => import("@/views/UserManage/Managers/Edit"),
  },
  //密钥管理：线上密钥 + 本地密钥
  {
    path: "/secretKeys/online",
    title: "线上密钥",
    component: () => import("@/views/SecretKeys/index.vue"),
  },
  {
    path: "/secretKeys/local",
    title: "本地密钥",
    component: () => import("@/views/LicenseLocal"),
  },
  {
    path: "/secretKeys/hub",
    title: "WirdHouse 授权",
    component: () => import("@/views/HubLicense"),
  },
  {
    path: "/secretKeys",
    redirect: "/secretKeys/online",
  },
  {
    path: "/licenseLocal",
    redirect: "/secretKeys/local",
  },
  //角色管理
  {
    path: "/roles",
    title: "角色管理",
    component: () => import("@/views/Roles"),
    children: [
      {
        path: "/roles",
        redirect: "/roles/list",
      },
      {
        path: "/roles/list",
        title: "角色列表",
        component: () => import("@/views/Roles/List"),
      },
      {
        path: "/roles/bindMenus",
        title: "菜单绑定",
        component: () => import("@/views/Roles/BindMenus"),
      },
    ],
  },
  //菜单管理
  {
    path: "/menus",
    title: "菜单管理",
    component: () => import("@/views/Menus"),
  },
  {
    path: "/menus/edit",
    title: "编辑",
    component: () => import("@/views/Menus/Edit"),
  },
  {
    path: "/menus/add",
    title: "新增",
    component: () => import("@/views/Menus/Edit"),
  },

  //帮助文档管理
  {
    path: "/helpDocuments",
    title: "帮助文档管理",
    component: () => import("@/views/HelpDocuments"),
  },
  {
    path: "/helpDocuments/edit",
    title: "编辑",
    component: () => import("@/views/HelpDocuments/Edit"),
  },
  {
    path: "/helpDocuments/add",
    title: "新增",
    component: () => import("@/views/HelpDocuments/Edit"),
  },
  //模板管理
  {
    path: "/templates",
    title: "模板管理",
    component: () => import("@/views/Templates"),
  },
];

export default routes;
